var config = [
    {
        type: 'discover',
        name: 'discover',
        pattern: /^(6011|65|64[4-9]|622)/,
        length: [16],
        formatter:'#### #### #### ####',
        except: ['CN', 'BR'],
        cvcLength: 3,
        dob: false,
        luhn: true
    },
    {
        type: 'amex',
        name: 'amex',
        pattern: /^3[47]/,
        format: /(\d{1,4})(\d{1,6})?(\d{1,5})?/,
        length: [15],
        formatter:'#### ###### #####',
        except: ['CN'],
        cvcLength: 4,
        dob: false,
        luhn: true
    },
    {
        type: 'confinoga',
        name: 'confinoga',
        pattern: /^(306005|306012|503203)/,
        length: [17],
        formatter:'##### #### #### ####',
        country: ['FR', 'GP', 'GF', 'MQ', 'RE', 'PF'],
        cvcLength: 0, // optional
        dob: true,
        luhn: true
    },
    {
        type: 'cb_nationale',
        name: 'cb_nationale',
        pattern: /^(675146|30[0-5])/,
        length: [16],
        formatter:'#### #### #### ####',
        country: ['FR', 'GP', 'GF', 'MQ', 'RE', 'PF'],
        cvcLength: 3,
        dob: false,
        luhn: true
    },
    {
        type: 'cetelem',
        name: 'cetelem',
        pattern: /^(501765|501766|54866[0-9]|41356[0-9]|40412[5-7]|404301|406249|406250|510017|510033|510034|518782|527599)/,
        length: [16, 19],
        formatter:'#### #### #### #### ###',

        country: ['FR', 'GP', 'GF', 'MQ', 'RE', 'ES', 'IT', 'PF'],
        cvcLength: 3,
        dob: true,
        luhn: true
    },
    /*{
     type: 'DINER',
     name: 'DINER',
     pattern: /^((30)[0-5]|309|36|38[0-8])/, // International
     length: [14, 15],
     cvcLength: 3,
     luhn: true
     },*/
    {
        type: 'switch',
        name: 'switch',
        pattern: /^6759[0-9]/,
        length: [16, 18, 19],
        formatter:'#### #### #### #### ###',
        country: ['GB'],
        cvcLength: 3,
        dob: false,
        luhn: true
    },
    {
        type: 'maestro',
        name: 'maestro',
        pattern: /^(5[06-8])/,
        length: [12, 13, 14, 15, 16, 17, 18, 19],
        formatter:'#### #### #### #### ###',
        country: ['BE', 'FR', 'ES', 'IT', 'PT', 'SK', 'RO', 'HU', 'RU', 'PL', 'TR'],
        cvcLength: 3,
        dob: false,
        luhn: true
    },
    {
        type: 'jcb',
        name: 'jcb',
        pattern: /^(35[28|29|[3-8])/,
        length: [16],
        formatter:'#### #### #### ####',
        country: ['JP'],
        cvcLength: 3,
        dob: false,
        luhn: true
    },
    {
        type: 'master_card',
        name: 'master_card',
        pattern: /^5[1-5]|2[2-7]2[0-1][0-9][0-9]/,
        length: [16, 17, 18, 19],
        formatter:'#### #### #### #### ###',
        except: ['CN'],
        cvcLength: 3,
        dob: false,
        luhn: true
    },
    {
        type: 'visa',
        name: 'visa',
        pattern: /^4[0-9]/,
        length: [13, 14, 15, 16, 17, 18, 19],
        formatter:'#### #### #### #### ###',
        except: ['CN'],
        cvcLength: 3,
        dob: false,
        luhn: true
    }];

module.exports = {
    type: function (name) {
        for (var i = 0, l = config.length; i < l; i++) {
            if (config[i].type === name) {
                return config[i];
            }
        }
    },
    match: function (number) {
        number = ('' + number).replace(/\s+?/, '');
        for (var i = 0, l = config.length; i < l; i++) {
            if (config[i].pattern.test(number)) {
                return config[i];
            }
        }
    }
}



/** WEBPACK FOOTER **
 ** ./src/types/card/cardConfig.js
 **/